<div class="main-container" style="display: flex">
  <div class="modal-close-btn" style="z-index: 1000">
    <button mat-mini-fab coloe="primary" (click)="cancel()" style="margin-right: 8px">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <ng-container *ngIf="mapOptions">
    <google-map
      [options]="mapOptions"
      [width]="width"
      [height]="height"
      *ngIf="loaded && !(gmapsLatitude == undefined || gmapsLatitude == 0) && !(gmapsLongitude == undefined || gmapsLongitude == 0)">
      <map-marker *ngIf="mapOptions.center" [position]="mapOptions.center" [options]="marker"></map-marker>
    </google-map>
  </ng-container>
  <div
    *ngIf="loaded && (gmapsLatitude == undefined || gmapsLatitude == 0) && (gmapsLongitude == undefined || gmapsLongitude == 0)"
    style="margin: 80px auto">
    <div class="warn-title title">Aucune coordonnée GPS enregistrée</div>
  </div>
</div>
